import { postAiRequest } from '../../common/ApiClient';
import { GetArticleRecommendationsResponse } from '../../ai-recommendation/types/GetArticleRecommendationsResponse';
import { ArticleTag } from '../../ai-recommendation/types/ArticleTag';
import { AiClickerPostData } from '../../ai-recommendation/types/AiClicker';

export const getArticleRecommendations = async (
  postId: number,
  country: 'HU' | 'SK' | 'CZ',
  articleTags: ArticleTag[],
  excludeIds: string[],
  categoryId: number,
  userToken: string,
  userId?: string,
  isLife?: boolean
): Promise<GetArticleRecommendationsResponse[]> => {
  const { data } = await postAiRequest<GetArticleRecommendationsResponse[]>(`recommendation/recommend`, {
    postId,
    country,
    articleTags,
    excludeIds,
    categoryId,
    isLife,
    userId,
    userToken,
  });

  return data;
};

export const sendClickedArticleData = async (data: AiClickerPostData): Promise<void> => {
  await postAiRequest<void>(`clicker/click`, data);
};
